'use client';

import { useEffect } from 'react';

import { useParamState } from '@lib';
import { toast } from 'sonner';

export const Share = ({ title, text }: { title: string; text: string }) => {
  const [sharing, setSharing] = useParamState('share', false);

  useEffect(() => {
    const share = async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title, text, url: window.location.href });
        } catch (error) {
          console.error('Error sharing:', error);
        }
      } else {
        toast.error('Sorry, sharing is not supported on this browser.');
      }
    };

    if (sharing) {
      share();
      setSharing(false);
    }
  }, [sharing]);

  return null;
};
